import { render, staticRenderFns } from "./MoveRecordingToFolderDialog.vue?vue&type=template&id=83e94e8e&scoped=true"
import script from "./MoveRecordingToFolderDialog.vue?vue&type=script&lang=js"
export * from "./MoveRecordingToFolderDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveRecordingToFolderDialog.vue?vue&type=style&index=0&id=83e94e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e94e8e",
  null
  
)

export default component.exports